module.exports = __webpack_public_path__ + "static/undraw_business_chat_ldig-13cbc77d86d2621fff455462ee1a61b8.svg";